// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    'backbone',
    './InterfaceModel'
], (Globals, $, _, Backbone, InterfaceModel) => {
    const InterfaceCollection = Backbone.Collection.extend({
        url: Globals.baseUrl + 'interfaces/interface',
        model: InterfaceModel
    }, {
        updateRole(roleId, newIds, options) {
            $.ajax({
                url: Globals.baseUrl + 'interfaces/listRoles',
                // contentType: "application/json; charset=utf-8",
                data: { ids: newIds, role_id: roleId }, // JSON.stringify({ids:ids}),
                dataType: 'JSON',
                type: 'put',
                success(data) {
                    if (_.isFunction(options.success)) {
                        options.success(data);
                    }
                }
            });
        }
    });
    return InterfaceCollection;
});



// WEBPACK FOOTER //
// ./src/components/interface/models/InterfaceCollection.js